import axios from 'axios';
import { installChallengeInterceptor } from '@/lib/cloudflareChallenge';

declare global {
    interface Window {
        axios: typeof axios;
    }
}

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

// Recover gracefully when an expired Cloudflare challenge intercepts a
// background request (see lib/cloudflareChallenge.ts).
installChallengeInterceptor(window.axios);
